import { render, staticRenderFns } from "./Socio.vue?vue&type=template&id=3c1065da&scoped=true"
import script from "./Socio.vue?vue&type=script&lang=js"
export * from "./Socio.vue?vue&type=script&lang=js"
import style0 from "./Socio.vue?vue&type=style&index=0&id=3c1065da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../.yarn/__virtual__/vue-loader-virtual-2b047b6fb3/8/home/ilcomi/.yarn/berry/cache/vue-loader-npm-15.11.1-829412283a-10c0.zip/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1065da",
  null
  
)

export default component.exports